import { render, staticRenderFns } from "./MatchPlayerEmpty.vue?vue&type=template&id=23a3a625&scoped=true"
import script from "./MatchPlayerEmpty.vue?vue&type=script&lang=js"
export * from "./MatchPlayerEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a3a625",
  null
  
)

export default component.exports